<script setup lang="ts">
  import { User, Users } from "lucide-vue-next";
  import { EmptyState } from "@/components/episto-ui/empty-state";
  import { Button } from "@/components/ui/button";

  defineProps<{ populationGrid: boolean }>();

  defineEmits<{ "add-rows": [] }>();
</script>

<template>
  <EmptyState
    size="lg"
    :icon="populationGrid ? Users : User"
    :title="populationGrid ? 'Build your population grid' : 'Build your respondent grid'"
    :description="
      populationGrid
        ? 'Pick the populations you want to compare, then ask AI questions: one synthesized answer per population, with citations.'
        : 'Pick the respondents you want to read side by side, then add survey questions, recodes or AI questions as columns.'
    ">
    <template #action>
      <Button @click="$emit('add-rows')">
        <component
          :is="populationGrid ? Users : User"
          class="size-4" />
        {{ populationGrid ? "Add populations" : "Add respondents" }}
      </Button>
    </template>
  </EmptyState>
</template>
